import axios from 'axios'
import { Row } from './convertSelectedDates'

async function fetchSelectedDates(year: Date, factory_id: number, headers: any): Promise<Row[]> {
  return axios.get(`/v0/factories/${factory_id}/factory-closed-dates`, {
    headers: headers,
    params: {
      factory_id: factory_id
    }
  })
    .then((res) => res.data)
    .catch((reason) => {
      throw reason
    })
}

export default fetchSelectedDates
